import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClimaLaboralRoutingModule } from './clima-laboral-routing.module';
import { CatalogoDimensionesComponent } from './catalogo-dimensiones/catalogo-dimensiones.component';
import { SharedModule } from '../../shared/shared.module';
import { ResultadosComponent } from './resultados/resultados.component';
import { MetodologiaComponent } from './metodologia/metodologia.component';
import { AnalisisCombinadoComponent } from './analisis-combinado/analisis-combinado.component';
import { PlanAccionComponent } from './plan-accion/plan-accion.component';
import { InformeComponent } from './informe/informe.component';
import { PerfilComponent } from './perfil/perfil.component';
import { SeguimientoPlanComponent } from './seguimiento-plan/seguimiento-plan.component';


@NgModule({
  declarations: [
    CatalogoDimensionesComponent,
    ResultadosComponent,
    MetodologiaComponent,
    AnalisisCombinadoComponent,
    PlanAccionComponent,
    InformeComponent,
    PerfilComponent,
    SeguimientoPlanComponent
  ],
  imports: [
    CommonModule,
    ClimaLaboralRoutingModule,
    SharedModule
  ]
})
export class ClimaLaboralModule { }
